import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypeMathseedsPrimeLessonResourceSkeleton } from './TypeMathseedsPrimeLessonResource'

export interface TypeMathseedsPrimeLessonFields {
  cover?: EntryFieldTypes.AssetLink
  curriculumId: EntryFieldTypes.Symbol<'au'>
  threadId: EntryFieldTypes.Symbol<'fractions' | 'geometry' | 'measurement' | 'number' | 'operations'>
  gradeId: EntryFieldTypes.Integer
  unitId: EntryFieldTypes.Integer
  unitName: EntryFieldTypes.Symbol
  lessonId: EntryFieldTypes.Integer
  lessonName: EntryFieldTypes.Symbol
  resources?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeMathseedsPrimeLessonResourceSkeleton>>
  content?: EntryFieldTypes.Text
  code?: EntryFieldTypes.Symbol
  label?: EntryFieldTypes.Symbol
}

export type TypeMathseedsPrimeLessonSkeleton = EntrySkeletonType<TypeMathseedsPrimeLessonFields, 'mathseedsPrimeLesson'>
export type TypeMathseedsPrimeLesson<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeMathseedsPrimeLessonSkeleton,
  Modifiers,
  Locales
>

export function isTypeMathseedsPrimeLesson<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeMathseedsPrimeLesson<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'mathseedsPrimeLesson'
}

export type TypeMathseedsPrimeLessonWithoutLinkResolutionResponse = TypeMathseedsPrimeLesson<'WITHOUT_LINK_RESOLUTION'>
export type TypeMathseedsPrimeLessonWithoutUnresolvableLinksResponse =
  TypeMathseedsPrimeLesson<'WITHOUT_UNRESOLVABLE_LINKS'>
export type TypeMathseedsPrimeLessonWithAllLocalesResponse<Locales extends LocaleCode = LocaleCode> =
  TypeMathseedsPrimeLesson<'WITH_ALL_LOCALES', Locales>
export type TypeMathseedsPrimeLessonWithAllLocalesAndWithoutLinkResolutionResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeMathseedsPrimeLesson<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>
export type TypeMathseedsPrimeLessonWithAllLocalesAndWithoutUnresolvableLinksResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeMathseedsPrimeLesson<'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES', Locales>
